import { toCamelCase } from '~/utils/object'

export function formatMessageThreadsRows(rows: any): any {
  // offer object to camel case (obsolete method after messages refactor)
  return rows.map(formatMessageThread)
}

export function formatMessageThread(r: any): any {
  if (r.offer) {
    return {
      ...r,
      offer: toCamelCase(r.offer)
    }
  }
  return r
}
